export default __webpack_public_path__ + "static/media/Harness of the Ubah Kan.fe76fb7c.jpg";